import LubanV2 from '@souche-f2e/luban-js-v2';
import { routerList } from './router/index';
import getUserID from "./assets/js/bury";

let userId = '';
const initConfig = {
    'appName': 'yizhihuan_h5',
    'projectId': 'chaoer',
    'uid': userId ? userId : '',
    'willSend': () => false,
    'router_mode': 'hash',
    'base': window.location.hash,
    'routes': routerList,
    'appVariable': true,
    'appEdition': true,
    'appTrackEnable': true,
    'impressionEnable': true,
    'autoTrackEnable': true,
    'positionEnable': false,
    'deviceEnable': true
};

const luban =async () => {
    userId = await getUserID();
    initConfig.uid=userId;
    LubanV2.load(initConfig);
};
export default luban;



// WEBPACK FOOTER //
// ./src/lubanV2.js